import { RangeerbewegingModel } from "@personeel/models/RangeerBewegingModel.ts";
import React from "react";

import { useRangeerbewegingenStore } from "@personeel/stores/RangeerBewegingenStore";
import "./BewegingGebondenKlusSoort.css";

interface BewegingGebondenKlusSoortProps {
  readonly errorMessage?: string;
  readonly selectedBeweging?: RangeerbewegingModel;
  readonly onBewegingSelected: (rangeerbewegingsactieId: string) => void;
  readonly selectedRangeerbewegingsactieId?: string;
}

export const BewegingGebondenKlusSoort: React.FC<BewegingGebondenKlusSoortProps> = ({
  errorMessage,
  selectedBeweging,
  onBewegingSelected,
  selectedRangeerbewegingsactieId,
}) => {
  const rangeerbewegingen = useRangeerbewegingenStore((state) => state.rangeerbewegingen);
  return (
    <>
      <div className={`form-group ${errorMessage ? "form-group-error" : ""}`}>
        <tractie-select
          label={"Bij beweging"}
          modelValue={selectedRangeerbewegingsactieId}
          name="rangeerbewegingsactieId"
        >
          <select
            data-testid="beweging-gebonden-klus-soort-select"
            className={errorMessage ? "error-border" : ""}
            slot="input"
            value={selectedRangeerbewegingsactieId || ""}
            onChange={(e) => onBewegingSelected(e.target.value)}
          >
            <option value="">Kies een beweging</option>
            {rangeerbewegingen.map((beweging) => (
              <option
                key={beweging.rangeerbewegingsactieId}
                value={beweging.rangeerbewegingsactieId}
              >
                V {beweging.start.tijd.toFormat("ccc HH:mm:ss")} {beweging.start.hoofdspoor.naam}{" "}
                {beweging.start.hoofdspoor.dienstregelpunt} - A{" "}
                {beweging.eind.tijd.toFormat("ccc HH:mm:ss")} {beweging.eind.hoofdspoor.naam}{" "}
                {beweging.eind.hoofdspoor.dienstregelpunt}
              </option>
            ))}
          </select>
        </tractie-select>
      </div>
      {errorMessage && <tractie-error-message text={errorMessage} className="error-margin" />}

      {selectedBeweging && (
        <div className="form-group">
          <div className="selected-beweging-details">
            <div className="beweging-row">
              <div className="beweging-column">V</div>
              <div className="beweging-column">
                {selectedBeweging.start.tijd.toFormat("ccc HH:mm:ss")}
              </div>
              <div>{selectedBeweging.start.hoofdspoor.naam}</div>
            </div>
            <div className="beweging-row">
              <div className="beweging-column">A</div>
              <div className="beweging-column">
                {selectedBeweging.eind.tijd.toFormat("ccc HH:mm:ss")}
              </div>
              <div>{selectedBeweging.eind.hoofdspoor.naam}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
